import { LoginService } from './../core/services/login.service';
import { GameService } from './../core/services/game.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EventsService } from '../core/services/events.service';

@Component({
  selector: "app-redeem",
  templateUrl: "./redeem.component.html",
  styleUrls: ["./redeem.component.scss"]
})
export class RedeemComponent implements OnInit {
  playerWallet;
  subError: boolean = false;
  subSuccess: boolean = false;

  constructor(
    public loginService: LoginService,
    private gameservice: GameService,
    private router: Router,
    private events: EventsService
    ) {}

  ngOnInit() {
    this.getPlayerData();
  }
  getPlayerData(){
    this.gameservice.getPlayerData().subscribe(data=>{
      this.playerWallet=data['responseData'].wallet.counters[3];
      //console.log(this.playerWallet);
    })
  }

  productBuy(searchKey) {
    this.events.eventStart({ eventType: 'REDEEM', triggerType: 'submit' });

    this.loginService.productBuy(searchKey).subscribe(data => {
      if (data['responseCode'] == 200) {
        if (data['responseData'].status == 'BILLINGERROR' || data['responseData'].status == 'NOT_BILLED' || data['responseData'].status == 'NOCREDIT') {
          this.events.eventStart({ eventType: 'REDEEM_ERROR', triggerType: 'error', responseData: JSON.stringify(data) });
          this.subError = true;
        } else {
          this.events.eventStart({ eventType: 'REDEEM_SUCCESS', triggerType: 'success', responseData: JSON.stringify(data) });
          this.subSuccess = true;
        }
      } else {
        this.events.eventStart({ eventType: 'REDEEM_ERROR', triggerType: 'error', responseData: JSON.stringify(data) });
        this.subError = true;
      }
    });
  }

  redirect(action) {
    if(action == 'success') {
      this.router.navigate(['/start-game']);
    }
  }
}
